import { Injectable } from '@angular/core';
import { KYMW7005Model } from '../kymw7005.model';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

@Injectable({
  providedIn: 'root'
})
export class UpdateFeatureGoodsListService extends PlessJsonResponderSub<null> {

  model: KYMW7005Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateFeatureRequestListService
   */
  private getBody(): PlessRequest {
    const updObj = {
      FeatureGoodsList: {
        combination: this.model.updateFeatureGoodsList.map(_ => 
          ({
          parameter: {
            OrderCode: _.OrderCode,
            MediumType: _.MediumType,
            OldFeatureCode: _.OldFeatureCode,
            NewFeatureCode: _.NewFeatureCode,
            PCode: _.PCode,
            ItemCode: _.ItemCode,
            BuyerNotice: _.NewBuyerNotice,
            SelectorType: _.SelectorType
          }
        })),
      },
    };
    if (updObj.FeatureGoodsList.combination.length < 1)
      delete updObj.FeatureGoodsList;
    return new PlessRequest({ update: updObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateFeatureRequestListService
   */
  execute(model: KYMW7005Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('updateFeatureGoodsList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof UpdateFeatureRequestListService
   */
  success() {
    if (this.calbak) this.calbak();
  }

}
